//@ts-nocheck
export const getRoleData = function (list) {
  let dataList = [];
  list?.forEach((element) => {
    dataList.push({
      name: element.charAt(0).toUpperCase() + element.slice(1),
      value: element.toLowerCase(),
    });
  });
  return dataList;
};